<script>
	import { throttle } from 'throttle-debounce'

	let width = 0
	let height = 0

	let html = document.documentElement

	const trackMouse = throttle(50, true, e => {
		if (width < 999) {
			return
		}
		let { pageX, pageY } = e
		if (pageY < height) {
			let x = (width / 2 - pageX) * -0.007
			let y = (height / 2 - pageY) * -0.007
			html.style.setProperty('--tx', `${x}px`)
			html.style.setProperty('--ty', `${y}px`)
		}
	})
</script>

<svelte:window on:mousemove={trackMouse} />

<div
	class="hero-background hb-transform"
	bind:offsetWidth={width}
	bind:offsetHeight={height} />
